import { Comment, Id, Identifiable, retrieveTaskError } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (projectId: Id) =>
    present(
      repository
        .getProjectLogs(projectId)
        .then((logs) => ({ projectId, logs }))
        .catch((e) =>
          Promise.reject({
            projectId,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
